import { render, staticRenderFns } from "./_SecondLevelMenuItem.vue?vue&type=template&id=3863de3c&"
import script from "./_SecondLevelMenuItem.vue?vue&type=script&lang=ts&"
export * from "./_SecondLevelMenuItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3863de3c')) {
      api.createRecord('3863de3c', component.options)
    } else {
      api.reload('3863de3c', component.options)
    }
    module.hot.accept("./_SecondLevelMenuItem.vue?vue&type=template&id=3863de3c&", function () {
      api.rerender('3863de3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/powerbar/components/PowerbarNav/_SecondLevelMenuItem.vue"
export default component.exports